// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "framer-motion") return "static/chunks/" + chunkId + "-0ba6c5dfd52a655c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e573246393a111e2" + ".js";
};